"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
function useFinancePackageFrequencyLabelProvider() {
    var intl = react_intl_1.useIntl();
    return function (packageCode, variant) {
        return intl.formatMessage({ id: "common.finance.packages." + packageCode + ".frequencyLabel." + variant });
    };
}
exports.default = useFinancePackageFrequencyLabelProvider;
